import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, ErrorHandler, NgModule, TransferState } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { TokenService } from '@app/auth/services';
import { AuthState } from '@app/auth/store';
import { EventsState } from '@app/events/store';
import { NewsState } from '@app/news/store';
import { ProfileState } from '@app/profile/store';
import { TokenInterceptor } from '@core/interceptors';
import { translateBrowserLoaderFactory } from '@core/loaders';
import { LocalizationService } from '@core/services';
import { CustomErrorHandler } from '@core/services/error-handler.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsModule } from '@ngxs/store';
import { SharedState } from '@shared/store';
import { CookieModule } from 'ngx-cookie';
import { Observable } from 'rxjs';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateBrowserLoaderFactory,
        deps: [HttpClient, TransferState],
      },
    }),
    NgxsModule.forRoot([AuthState, EventsState, ProfileState, NewsState, SharedState]),
    CookieModule.withOptions(),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (service: LocalizationService) => (): Observable<any> => service.init(),
      multi: true,
      deps: [LocalizationService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (service: TokenService) => (): Observable<boolean> => service.init(),
      multi: true,
      deps: [TokenService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
